const actions = {
    GET_API_KEY_BY_DEALER_ID: 'GET_API_KEY_BY_DEALER_ID',
    GET_API_KEY_BY_DEALER_ID_SUCCESS: 'GET_API_KEY_BY_DEALER_ID_SUCCESS',
    GET_API_KEY_BY_DEALER_ID_FAILED: 'GET_API_KEY_BY_DEALER_ID_FAILED',

    ADD_UPDATE_API_KEY: "ADD_UPDATE_API_KEY",
    ADD_UPDATE_API_KEY_SUCCESS: "ADD_UPDATE_API_KEY_SUCCESS",
    ADD_UPDATE_API_KEY_FAILED: "ADD_UPDATE_API_KEY_FAILED",

    RESET_MESSAGE: "RESET_MESSAGE",

    OPEN_API_KEY_MODAL: "OPEN_API_KEY_MODAL",
    CLOSE_API_KEY_MODAL: "CLOSE_API_KEY_MODAL",

    RESET_SEARCH_DATA: "RESET_SEARCH_DATA",


    getApiKey: (dealerId) => ({
        type: actions.GET_API_KEY_BY_DEALER_ID,
        dealerId
    }),
    getApiKeySuccess: (result) => ({
        type: actions.GET_API_KEY_BY_DEALER_ID_SUCCESS,
        result
    }),
    getApiKeyFailed: (error) => ({
        type: actions.GET_API_KEY_BY_DEALER_ID_FAILED,
        error
    }),
    addUpdateApiKey: (data) => ({
        type: actions.ADD_UPDATE_API_KEY,
        payload: { data }
    }),
    addUpdateApiKeySuccess: (message, result) => ({
        type: actions.ADD_UPDATE_API_KEY_SUCCESS,
        message, result
    }),
    addUpdateApiKeyFailed: (error) => ({
        type: actions.ADD_UPDATE_API_KEY_FAILED,
        error
    }),

    openApiKeyModal: () => ({
        type: actions.OPEN_API_KEY_MODAL,
    }),
    closeApiKeyModal: () => ({
        type: actions.CLOSE_API_KEY_MODAL,
    }),

    resetMessage: () => ({
        type: actions.RESET_MESSAGE,
    }),
    resetSearchData: () => ({
        type: actions.RESET_SEARCH_DATA,
    }),
};
export default actions;
